import { render, staticRenderFns } from "./ExperienceDNA.vue?vue&type=template&id=188d9fed&scoped=true"
import script from "./ExperienceDNA.vue?vue&type=script&lang=js"
export * from "./ExperienceDNA.vue?vue&type=script&lang=js"
import style0 from "./ExperienceDNA.vue?vue&type=style&index=0&id=188d9fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_css-loader@6.11.0_webpack@5.108.4_clean-css_8f79fb19793044b4215c482fdb8be9e8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d9fed",
  null
  
)

export default component.exports